module.exports = __webpack_public_path__ + "static/media/kamran.80cd5623.png";